import { BinderService } from '@/services/api/binder.service';
import { UsersService } from '@/services/api/users.service';
import { Component, effect, EventEmitter, Output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Subscription } from 'rxjs';
import { Binder } from 'src/app/models/binder.model';
import { UserData } from 'src/app/models/user-data.model';

@Component({
    selector: 'app-recipients',
    imports: [
        TableModule
    ],
    template: `
    <p-table [value]="recipients" [(selection)]="selectedRecipients" dataKey="email" [tableStyle]="{'width': '100%'}" (onSelectionChange)="selectionChange.emit(selectedRecipients)">
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 4rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Name</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
        <tr>
            <td>
                <p-tableCheckbox [value]="user"></p-tableCheckbox>
            </td>
            <td>{{user.name}}</td>
        </tr>
    </ng-template>
</p-table>
    `
})
export class RecipientsComponent {
  binder!:Binder;
  userData!:UserData[];
  @Output() selectionChange = new EventEmitter<{name: string, email: string}[]>();

  userListSubscription!:Subscription;
  userList!:UserData[];
  recipients!: {name:string,email:string}[];
  selectedRecipients!: {name:string,email:string}[];

  builderEmails!:{email:string}[];

  constructor(
    private currentBinderService: BinderService,
    private userListService: UsersService
    ) {
      effect(() => {
        const binder = this.currentBinderService.currentBinder();
        const userList = this.userListService.userList();
        if(binder) {
          this.binder = binder;
          if(this.userList) {
            this.filterRecipients(binder.SelectedFID,this.userList);
          }
        }
        if(userList) {
          this.userList = userList;
          if(this.binder) {
            this.filterRecipients(this.binder.SelectedFID,this.userList);
          }
        }
      });
    }

filterRecipients(fid:number,data:UserData[]) {
    this.recipients = data
      .filter(user => 
        user.UserRoles?.some(role => 
          role.PermRoles?.RoleAccess?.some(access => 
            access.AccessPermissions.dataTable === 'Binders' && (access.AccessPermissions.FID === fid || access.AccessPermissions.FID === 0) && access.AccessPermissions.permType === 'view'
          )
        )
      )
      .map(user => ({
        name: user.DisplayName, 
        email: user.User || '' // Provide a fallback value to ensure it's always a string
      }))
      .filter(email => email.email); // Optionally, filter out any entries with an empty 'value'
}
}
